<template>
    <div>
        <v-row justify="center">
            <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
            >
            <v-card>
                <v-card-title>
                <span v-if="Item.id == 0" class="text-h5">Nuevo Catologo</span>
                <span v-else class="text-h5">Editar Catologo</span>
                <v-spacer></v-spacer>
                <span v-if="Item.id > 0" >ID: {{Item.id}}</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <!-- <FormularioDinamico :campos="campos"/> -->
                    <v-row>
                    <v-col
                        cols="12"
                        md="6"
                        sm="12"
                    >
                        <v-autocomplete
                            class="mt-5"
                            :items="ItemsTipo"
                            v-model="Item.TIP_Nombre"
                            label="Tipo *"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        sm="12"
                    >
                        <v-text-field
                        label="Nombre *"
                        hide-details="auto"
                        v-model="Item.PRO_Nombre"
                        required
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        sm="12"
                    >
                        <v-text-field
                        label="Color *"
                        hide-details="auto"
                        v-model="Item.PRO_Color"
                        required
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        sm="12"
                    >
                        <v-text-field
                        label="Encaje"
                        hide-details="auto"
                        v-model="Item.PRO_Encaje"                        
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        sm="12"
                    >
                        <v-text-field
                        label="Tela *"
                        hide-details="auto"
                        v-model="Item.PRO_Tipo_Tela"
                        required
                        ></v-text-field>
                    </v-col>
                    </v-row>
                </v-container>
                <small>*indica los campos requeridos</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    @click="cerrarDialogo()"
                >
                    Cerrar
                </v-btn>
                <v-btn
                    color="info"
                    @click="agregar()"
                >
                    Guardar
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
import { mapGetters ,mapActions } from 'vuex';
export default {
    props:['dialog','Item'],
    methods:{
        ...mapActions('producto',['agregarProducto',"cargarProducto"]),
        agregar(){
            this.$alertify.confirm(
                this.Item.id  == 0 ? "Desea Agregar Item" : "Desea Editar Item", 
                () => {
                    this.agregarProducto(this.Item);
                    this.cerrarDialogo();
                    this.$alertify.success(this.Item.id  == 0 ? "Agregado" : "Actualizado");
                    }, 
                () => this.$alertify.error("Se cancelo la acción")
            ).setHeader('<em> Aviso </em> ');
        },
        cerrarDialogo(){
            this.cargarProducto;
            this.$emit('dialog',false);
        }
    },
    computed:{
        ...mapGetters('producto',['ItemsTipo'])    
    },
    data() {
        return {

        };
    },
}
</script>
